import { type LoaderFunctionArgs } from "react-router";

import type { FetchPolicy } from "@apollo/client";

import {
  DashboardProjectsDetailsDocument,
  type DashboardProjectsDetailsQuery,
  type DashboardProjectsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

const loadProject = async (
  { params }: LoaderFunctionArgs,
  fetchPolicy: FetchPolicy,
) => {
  const id = params.id;
  if (!id) throw new Error("undefined ID");

  const { data } = await client.query<
    DashboardProjectsDetailsQuery,
    DashboardProjectsDetailsQueryVariables
  >({
    query: DashboardProjectsDetailsDocument,
    variables: { id },
    fetchPolicy,
  });

  return data;
};

// The `:id` route: the one place this query goes to the network on open. The
// screen then reads what lands here out of the cache.
export const DASHBOARD_PROJECTS_DETAILS_LOADER = (props: LoaderFunctionArgs) =>
  loadProject(props, "network-only");

// Children of `:id` that only need the project for their breadcrumb. The
// parent has already fetched it and is not re-run on a child navigation, so
// going network here would re-download the whole project per hop.
export const DASHBOARD_PROJECTS_DETAILS_CACHED_LOADER = (
  props: LoaderFunctionArgs,
) => loadProject(props, "cache-first");
